<script setup>
import { computed } from 'vue'
import { getI18n } from '@/plugins/i18n'

import { usePlanningStore } from '@/stores/planning.store'
import { infoBoxToneEnum } from '@/stores/portal.store'

import InfoBox from '@/components/shared/InfoBox.vue'

const props = defineProps({
  serviceIds: {
    type: Array,
    required: true,
  },
})

const i18n = getI18n()
const planningStore = usePlanningStore()

const names = computed(() => props.serviceIds.map(id => planningStore.getServiceName(planningStore.getServiceById(id), true)).join(', '))
</script>

<template>
  <info-box
    v-if="serviceIds.length"
    :tone="infoBoxToneEnum.WARNING"
    :message="i18n.t('common.tasks.missingServicesWarning', { names }, serviceIds.length)"
  />
</template>
